import { render, staticRenderFns } from "./MyFormulateAutocomplete.vue?vue&type=template&id=edd495b8&"
import script from "./MyFormulateAutocomplete.vue?vue&type=script&lang=js&"
export * from "./MyFormulateAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports